import React, { useEffect, useState } from 'react';
import "./Setting.css";
import { FaUser } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaUserCheck, FaCheckCircle } from "react-icons/fa";
import { IoCloudUpload } from "react-icons/io5";
import { HiOutlineBookOpen } from "react-icons/hi";
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../insightConfig/insightConfig';
import axios from 'axios';
import { RiDownload2Fill } from "react-icons/ri";
import { Spinner } from 'react-bootstrap';
import { getCookie } from '../../commonServices/cookieService';

const getFullFileUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
    const safePath = normalizedPath.split('\\').join('/');
    return `${BASE_URL}/${safePath}`;
};

function Setting({ userDtails }) {
    const formatExamType = (type) => {
        if (!type) return '';
        const t = type.toLowerCase();
        if (t === 'neet') return 'NEET';
        if (t === 'cuet') return 'CUET';
        if (t === 'ugc-net') return 'UGC-NET';
        if (t === 'civil services') return 'Civil Services';
        return type.toUpperCase();
    };

    const authtoken = localStorage.getItem('authtoken');
    const jwtToken = localStorage.getItem('token');
    const alert = useAlert();
    const navigate = useNavigate();
    const [FirstName, setFirstName] = useState(userDtails.FirstName);
    const [MobileNo, setMobileNo] = useState(userDtails.MobileNo);
    const [Address, setAddress] = useState(userDtails.Address);
    const [AadharNo, setAadharNo] = useState(userDtails.AadharNo || '');
    const [date, setDate] = useState(userDtails.Date);
    const [Month, setMonth] = useState(userDtails.Month);
    const [Year, setYear] = useState(userDtails.Year);
    const [error, setError] = useState('');
    const [academicQFile, setAcademicQFile] = useState(null);
    const [addressProofFile, setAddressProofFile] = useState(null);
    const [academicQFilePath, setAcademicQFilePath] = useState(userDtails?.AcedemicQualification);
    const [addressProofFilePath, setAddressProofFilePath] = useState(userDtails?.AddressProof);
    const [fileUploading1, setFileUploading1] = useState(false);
    const [fileUploading2, setFileUploading2] = useState(false);
    const [sendingEmail, setSendingEmail] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(userDtails.EmailVerify);

    // Function to format the date of birth
    const formatDateOfBirth = () => {
        const formattedDate = String(date).padStart(2, '0');
        const formattedMonth = String(Month + 1).padStart(2, '0'); // Adding 1 to month because months are zero-indexed
        return `${Year}-${formattedMonth}-${formattedDate}`;
    };

    const handleUpdateUser = async (e) => {
        e.preventDefault();
        if (!FirstName.trim()) {
            alert.show('Please Enter Name');
            setError('Please fill all fields');
            return;
        } else if (!MobileNo.trim()) {
            alert.show('Please Enter Mobile Number');
            setError('Please fill all fields');
            return;
        }

        if (AadharNo && AadharNo.trim()) {
            const cleanAadhar = AadharNo.trim();
            if (!/^\d{12}$/.test(cleanAadhar)) {
                alert.show('Aadhaar Number must be exactly 12 digits');
                setError('Aadhaar Number must be exactly 12 digits');
                return;
            }
        }

        try {
            const response = await axios.post(`${BASE_URL}/update-student`, {
                FirstName, MobileNo, Address, "Date": date, Month, Year, academicQFilePath, addressProofFilePath, AadharNo
            }, {
                headers: {
                    'Authorization': `Bearer ${jwtToken || authtoken}`
                }
            })
            if (response.data.statusCode !== 200) {
                throw new Error('Update User failed');
            }
            // Reset form fields and state
            setFirstName(userDtails.FirstName)
            setMobileNo(userDtails.MobileNo);
            setAddress(userDtails.Address);
            setAadharNo(userDtails.AadharNo || '');
            setDate(userDtails.Date);
            setMonth(userDtails.Month);
            setYear(userDtails.Year);
            // Show login success message
            alert.show('Update User successfully');
            navigate("/login");
        } catch (error) {
            setError('Error while updating the use details');
            alert.show('Error while updating the use details')
        }
    };

    const sendVerificationEmail = async () => {
        setSendingEmail(true);
        try {
            const response = await axios.post(`${BASE_URL}/send-verification-email`, {}, {
                headers: {
                    'Authorization': `Bearer ${jwtToken || authtoken}`
                }
            });
            if (response.data.statusCode === 200) {
                alert.show('Verification email sent! Please check your inbox.');
            } else {
                alert.show(response.data.message || 'Failed to send verification email');
            }
        } catch (error) {
            console.error('Error sending verification email:', error);
            alert.show('Error sending verification email');
        } finally {
            setSendingEmail(false);
        }
    };

    useEffect(() => {
        const formData = new FormData();
        if (academicQFile) {
            //upload image on server 
            setFileUploading1(true)
            formData.append('uploadedFile', academicQFile, academicQFile.name);
            axios.post(BASE_URL + '/uploadFile', formData)
                .then((response) => {
                    if (response.data.statusCode == 201) {
                        setAcademicQFilePath(response.data.imagePath)
                        setAcademicQFile(null)
                        setAddressProofFile(null)
                        setTimeout(() => {
                            alert.show('File uploaded Successfully')
                            setFileUploading1(false)
                        }, 1500)
                    }
                })
                .catch(error => {
                    console.error(error.response.data.message);
                });
        } else if (addressProofFile) {
            setFileUploading2(true)
            formData.append('uploadedFile', addressProofFile, addressProofFile.name);
            axios.post(BASE_URL + '/uploadFile', formData)
                .then((response) => {
                    if (response.data.statusCode == 201) {
                        setAddressProofFilePath(response.data.imagePath)
                        setAcademicQFile(null)
                        setAddressProofFile(null)

                        setTimeout(() => {
                            alert.show('File uploaded Successfully')
                            setFileUploading2(false)
                        }, 1500)

                    }
                })
                .catch(error => {
                    console.error(error.response.data.message);
                });
        }
    }, [academicQFile, addressProofFile])

    const selectedFileHandler = (fileName, file) => {
        if (fileName == 'AcademicFile') {
            setAcademicQFile(file)
            setAddressProofFile(null)
        } else {
            setAddressProofFile(file)
            setAcademicQFile(null)
        }

    }


    return (
        <>
            <div className='Setting-background'>
                <form onSubmit={handleUpdateUser}>
                    <div className='row'>
                        <div className="col-lg-6 col-sm-12">
                            <label className="form-label fw-bold"><FaUser className='me-2' />Full Name <span className='text-danger'>*</span></label>
                            <input type="text" className="form-control" value={FirstName} onChange={(e) => setFirstName(e.target.value)} />
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <label className="form-label fw-bold"><IoCalendarOutline className='me-2' /> Date Of Birth <span className='text-danger'>*</span></label>
                            <input type="date" className="form-control" value={formatDateOfBirth()} onChange={(e) => {
                                const selectedDate = new Date(e.target.value);
                                setDate(selectedDate.getDate());
                                setMonth(selectedDate.getMonth());
                                setYear(selectedDate.getFullYear());
                            }} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-6 col-sm-12">
                            <label className="form-label fw-bold"><MdEmail className='me-2' />Email <span className='text-danger'>*</span></label>
                            <div className="verification-container">
                                <input
                                    type="email"
                                    className="form-control mb-0"
                                    value={userDtails.EmailId}
                                    readOnly
                                    style={{ flex: '1 1 200px', height: '48px', fontSize: '14px', minWidth: '0' }}
                                />
                                <div className={`verification-badge ${isEmailVerified ? 'badge-verified' : 'badge-not-verified'}`}>
                                    {isEmailVerified ? (
                                        <>
                                            <FaUserCheck className="mb-1" /> Verified
                                        </>
                                    ) : (
                                        <>
                                            <span>Not Verified</span>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm btn-verify-now"
                                                onClick={sendVerificationEmail}
                                                disabled={sendingEmail}
                                            >
                                                {sendingEmail ? <Spinner animation="border" size="sm" style={{ width: '12px', height: '12px' }} /> : 'Verify Email Now'}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <label className="form-label fw-bold"><FaPhoneAlt className='me-2' />Mobile <span className='text-danger'>*</span></label>
                            <input type="number" className="form-control" id="exampleInputPassword1" value={MobileNo} onChange={(e) => setMobileNo(e.target.value)} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-6 col-sm-12">
                            <label className="form-label fw-bold"><HiOutlineBookOpen className='me-2' />Exam</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formatExamType(userDtails.ExamType) || 'Civil Services'}
                                readOnly
                                style={{
                                    backgroundColor: '#f1f3f5',
                                    cursor: 'not-allowed',
                                    fontWeight: '600',
                                    color: '#495057'
                                }}
                            />
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <label className="form-label fw-bold"><FaUserCheck className='me-2' />Aadhar Number</label>
                            <input
                                type="text"
                                className="form-control"
                                value={AadharNo}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, ''); // Keep only numeric digits
                                    if (val.length <= 12) {
                                        setAadharNo(val);
                                    }
                                }}
                                placeholder="Enter Aadhar Number"
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-6 col-sm-12">
                            <label htmlFor='file1' className="form-label fw-bold d-flex align-items-center"><FaUserCheck className='me-2' />Academic Qualification {(academicQFilePath || userDtails?.AcedemicQualification) && <FaCheckCircle className='ms-2 text-success' title="Uploaded" />}</label>
                            <div className="d-flex align-items-center">
                                <label htmlFor="file1" className="custom-input w-75 d-flex align-items-center justify-content-center mb-0" style={{ cursor: 'pointer' }}>
                                    <IoCloudUpload className='upload-icon1 me-1' size={23} />
                                    <span>{academicQFilePath || userDtails?.AcedemicQualification ? 'Change File' : 'Upload File'}</span>
                                </label>
                                {fileUploading1 ? <Spinner className='ms-2' variant="info" /> : (academicQFilePath || userDtails.AcedemicQualification) && <RiDownload2Fill style={{ cursor: "pointer" }} onClick={() => window.open(getFullFileUrl(academicQFilePath || userDtails?.AcedemicQualification), '_blank')} className='ms-2 bg-gray' color='green' size={40} title="Download File" />}
                            </div>
                            <input id="file1" style={{ display: "none" }} type="file" accept=".pdf" onChange={(event) => selectedFileHandler('AcademicFile', event.target.files[0])} />
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <label htmlFor='file2' className="form-label fw-bold d-flex align-items-center"><FaUserCheck className='me-2' />Address & ID Proof {(addressProofFilePath || userDtails?.AddressProof) && <FaCheckCircle className='ms-2 text-success' title="Uploaded" />}</label>
                            <div className="d-flex align-items-center">
                                <label htmlFor="file2" className="custom-input w-75 d-flex align-items-center justify-content-center mb-0" style={{ cursor: 'pointer' }}>
                                    <IoCloudUpload className='upload-icon1 me-1' size={23} />
                                    <span>{addressProofFilePath || userDtails?.AddressProof ? 'Change File' : 'Upload File'}</span>
                                </label>
                                {fileUploading2 ? <Spinner className='ms-2' variant="info" /> : (addressProofFilePath || userDtails?.AddressProof) && <RiDownload2Fill style={{ cursor: "pointer" }} onClick={() => window.open(getFullFileUrl(addressProofFilePath || userDtails?.AddressProof), '_blank')} className='ms-2 bg-gray' color='green' size={40} title="Download File" />}
                            </div>
                            <input id="file2" style={{ display: "none" }} accept=".pdf" type="file" onChange={(event) => selectedFileHandler('AddressProof', event.target.files[0])} />
                        </div>
                        {/* <div className="col-lg-6 col-sm-12">
                            <label htmlFor='file2' className="form-label fw-bold"><FaUserCheck className='me-2' />Address & ID Proof</label>
                            <IoCloudUpload className='upload-icon2' /><input id='file2' type="file" className="" />
                        </div> */}
                    </div>
                    <div className='row'>
                        <div className="col-lg-12 col-sm-12">
                            <label className="form-label fw-bold"><FaLocationDot className='me-2' />Postal Address</label>
                            <textarea className="form-control" rows="3" value={Address} onChange={(e) => setAddress(e.target.value)}></textarea>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                        <button type="submit" className="btn btn-save">Save</button>
                    </div>
                </form>
                {/* Error message if login fails */}
                {error && <p>{error}</p>}
            </div>
        </>
    )
}

export default Setting;